import Swiper, { SelectableElement, SwiperOptions } from 'swiper';

const instance = (container: SelectableElement, options?: SwiperOptions) => {
  return new Swiper(container, options);
};

export default {
  instance
};
